module.exports = [
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 12.5
  },
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 11.03
  },
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 11.67
  },
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 11.23
  },
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 11.03
  },
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 13.2
  },
  {
    "COD": "Suicide",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 15
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 10.53
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 10.9
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 11.03
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 11.8
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 12.5
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 13.23
  },
  {
    "COD": "Suicide",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 14.1
  }
]
